import React from 'react';
import './Home.css'
import cv from '../../Images/Abidur-cv.pdf'
import Header2 from '../Header/Header2';
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';

const Home = () => {
    return (

        < >
            <div className="row">
                <div className="col-md-3">
                    <Header2 />
                </div>
                <div className="col-md-9">
                    <div style={{ height: '600px', }} className="row d-flex align-items-center">
                        <div left className='px-5'>
                            <h3>HI, THERE!</h3>
                            <Fade top><h1 className='header-text pb-2'> I'm <span className='theme-color'> Abidur Rahman </span></h1> </Fade>
                            <Bounce ><p className='portfolio-paragrap' cascade >A front end developer is build website
                                so that it is functional and user-friendly <br />
                                I have a strong passion for the 
                                creativity and discipline that goes into
                                front-end development.  <br /> Keeping in
                                mind scalability and clean code that is
                                maintainable and readable.
                            </p></Bounce>
                            <a href={cv} className='mi-button' download>DOWNLOAD CV</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;